import React from 'react';
import { connect } from 'react-redux';
import { history } from 'redux/store';
import MenuItem from '@mui/material/MenuItem';
import KATlogo from 'static/images/mvp/KATlogo.png';
import USDTlogo from 'static/images/mvp/USDTlogo.png';
import PAXGlogo from 'static/images/mvp/PAXGlogo.png';
import BNBlogo from 'static/images/mvp/BNBLogo.png';
import ETHlogo from 'static/images/mvp/ETHLogo.png';
import POLlogo from 'static/images/mvp/POLlogo.png';
import ZETAlogo from 'static/images/mvp/ZETAlogo.png';
import { ethers } from 'ethers';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import ServiceRevenueSharingABI from 'abis/ServiceRevenueSharing.js';
import KATABI from 'abis/KAT.js';
import USDTABI from 'abis/USDT.js';
import PAXGABI from 'abis/PAXG.js';

import {
  Box,
  Typography,
} from '@mui/material';
import FormControl from '@mui/material/FormControl';
import CardPackagePayment from './CardPackagePayment';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import arrowBackIosIcon from 'static/images/mvp/solar_arrow-left-linear.png';
import loadingIcon from 'static/images/mvp/uiw_loading.png';
import successIcon from 'static/images/mvp/basil_check-solid.png';
import '../../custom-home.scss';
import './packages-payment.scss';
import ConfirmationDialog from './ConfirmationDialog';
import { Button } from '@kambria/kambria-lego';

import { Row } from 'antd';
import {
  getKatUSDTQuote,
  getCedPackageById,
  getDaoDetailByCode,
  registerPackage,
  getWalletSessionByUserId,
} from 'redux/actions/mvp/ced-package.action.js';
import { fetchUserMvp } from 'redux/actions/user.action';
import { I18n } from '../../../../../helpers/i18n';

class Payment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      paidCurrency: 'USDT', // giá trị mặc định
      title: '',
      priceUsdt: '',
      totalSession: '',
      totalDay: '',
      packageMainColor: '',
      packageSubColor: '',
      ServiceRevShareAddress: '',
      chainID: 1,
      infoNoti: '',
      infoStatus: '',
      showConfirmationDialog: false,
      confirmedQuote: 0,
      isButtonDisabled: false,
      isButtonDisplay: true,
      isDisplayPaymentArea: true,
      isDisplayPAXGPaymentArea: false,
    };
  }

  formatAmount = (price) => {
    if (price === null || price === undefined || isNaN(price)) {
      return '0';
    }
    const n = Number(price);
    if (!isFinite(n)) {
      return '0';
    }
    // Hiển thị tối đa 18 chữ số thập phân, tránh dạng e-notation
    // và loại bỏ các số 0 không cần thiết ở cuối
    return n
      .toFixed(18)
      .replace(/\.0+$/, '')
      .replace(/(\.\d*[1-9])0+$/, '$1');
  }

  getQuote = async () => {
    const { getKatUSDTQuote } = this.props;
    const quote = await getKatUSDTQuote();
    if (quote && quote.success && quote.data) {
      this.setState({
        katQuote: quote.data.katToUSD || 0,
        usdtQuote: quote.data.usdtToUSD || 0,
        paxgQuote: quote.data.paxgToUSD || 0,
        bnbQuote: quote.data.bnbToUSD || 0,
        ethQuote: quote.data.ethToUSD || 0,
        zetaQuote: quote.data.zetaToUSD || 0,
      });
    } else {
      console.error('Failed to fetch quotes:', quote?.error);
      // Keep existing state values if API call fails
    }
  };

  componentWillUnmount() {
    // Dừng gọi hàm khi component bị gỡ bỏ
    clearInterval(this.quoteInterval);
  }

  async componentDidMount() {
    const {
      getKatUSDTQuote,
      getCedPackageById,
      getDaoDetailByCode,
      registerPackage,
      getWalletSessionByUserId,
      match,
    } = this.props;
    const quote = await this.getQuote();
    try {
      const PAXGAddress = await revSharServiceContract.currencyAddresses(2);
      this.setState({ isDisplayPAXGPaymentArea: true });
    } catch (error) {
      this.setState({ isDisplayPAXGPaymentArea: false });
    }
    // Thiết lập interval để gọi hàm mỗi 10 giây
    this.quoteInterval = setInterval(() => {
      this.getQuote();
    }, 5000); // 10000 ms = 10 giây
    const { params } = match;
    const packageId = params.id;
    const packageResponse = await getCedPackageById(packageId);
    const userDataId = JSON.parse(localStorage.getItem('ced:user-info'))._id;
    const walletSession = await getWalletSessionByUserId(userDataId);
    // Kiểm tra nếu packageResponse có success bằng false

    if (packageResponse.success === false) {
      // Redirect đến trang 404
      history.push('/404');
      return;
    }
    const packageResponseData = packageResponse.data.data;
    // console.log("CED")
    const daoInfo = await getDaoDetailByCode('CED');
    // console.log("packageResponseData", packageResponseData.pricePaxg)
    this.setState({
      packageId: packageResponseData?._id ? packageResponseData?._id : packageResponseData.id,
      packageTitle: packageResponseData.title,
      priceOrigin: packageResponseData.priceOrigin,
      priceKat: packageResponseData.priceKat,
      priceUsdt: packageResponseData.priceUsdt,
      // pricePaxg: packageResponseData.priceUsdt,
      totalSession: packageResponseData.totalSession,
      totalDay: packageResponseData.totalDay,
      packageMainColor: packageResponseData.packageMainColor,
      packageSubColor: packageResponseData.packageSubColor,
      saleOffPercentage: packageResponseData.saleOffPercentage,
      saleOffPercentageWithKATPayment: packageResponseData.saleOffPercentageWithKATPayment,
      chainID: daoInfo.data.data.chainId,
      daoInfo: daoInfo.data.data,
      ServiceRevShareAddress: daoInfo.data.data.serviceRevenueSharingAddress,
      walletSessionData: walletSession?.data?.data ?? null,
    });

    if (!this.state.ServiceRevShareAddress || !ethers.utils.isAddress(this.state.ServiceRevShareAddress)) {
      toast.info(I18n.t('payment_package_setup_error'), {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: 'colored',
        className: 'toast-info-container',
      });
    }
    if (walletSession.success === true) {
      //Tính toán start và endDate
      const today = new Date();
      const expiredDate = new Date(walletSession.data.data.expiredDate);
      const existSession = walletSession.data.data.existSession;
      // const existedSession = walletSession.data.data.session;
      let endDate;
      const hasActiveSubscription = expiredDate >= today && existSession > 0;
      if (hasActiveSubscription) {
        endDate = new Date(expiredDate.getTime() + this.state.totalDay * 24 * 60 * 60 * 1000); // Adding totalDay days to expiredDate
      } else {
        endDate = new Date(today.getTime() + this.state.totalDay * 24 * 60 * 60 * 1000); // Adding totalDay days to today
      }

      this.setState({
        startDate: today,
        endDate: endDate,
        currentPackageExpiredDate: hasActiveSubscription ? expiredDate : null,
      });
    } else {
      const today = new Date();

      this.setState({
        startDate: today,
        endDate: new Date(today.getTime() + this.state.totalDay * 24 * 60 * 60 * 1000), // Adding totalDay days to today
        currentPackageExpiredDate: null,
      });
    }
  }
  openConfirmationDialog = async () => {
    this.setState({
      showConfirmationDialog: true,
    });
  };
  connectMetamask = async () => {
    if (window.ethereum) {
      try {
        const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
        this.setState({ walletAddress: accounts[0] });
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const signer = provider.getSigner();
        this.signer = signer;
        // Lấy chain ID
        const network = await provider.getNetwork();
        const chainId = network.chainId;
        this.setState({ UserChainId: chainId });
        return true;
      } catch (error) {
        toast.info(I18n.t('payment_package_metamask_login'), {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: 'colored',
          className: 'toast-info-container',
        });
        return false;
      }
    } else {
      toast.info(I18n.t('payment_package_metamask_setup'), {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: 'colored',
        className: 'toast-info-container',
      });
      return false;
    }
  };
  handleChangeCurrency = (event) => {
    this.setState({
      paidCurrency: event.target.value,
      confirmedQuote: 0,
    });
  };

  handlePayment = async () => {
    // Code to execute when the button is clicked

    const { registerPackage, fetchUserMvp } = this.props;

    const isConnectMetamask = await this.connectMetamask();
    if (!isConnectMetamask) {
      return;
    }

    if (this.state.UserChainId.toString() !== this.state.chainID.toString()) {
      // Define a mapping of chain IDs to network names
      const networkNames = {
        1: 'Ethereum',
        56: 'Binance Smart Chain',
        137: 'Polygon',
        7001: 'ZetaChain Testnet',
      };

      // Get the network name based on this.state.chainID
      const networkName = networkNames[this.state.chainID.toString()] || 'Unknown Network';

      // Display the toast with the network name included
      toast.info(I18n.t('change_chain_network', {networkName, chainID: this.state.chainID}), {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: 'colored',
        className: 'toast-info-container',
      });
      return;
    }

    this.setState({
      isButtonDisabled: true,
      isButtonDisplay: false,
    });

    // Define the arguments
    const revSharServiceContract = new ethers.Contract(
      this.state.ServiceRevShareAddress,
      ServiceRevenueSharingABI,
      this.signer,
    );

    const orderID = Math.floor(Math.random() * 1000000000) + 1; // Sau này thay bằng logic tạo order ID (hiện kiểu dữ liệu đang là số nguyên)
    let paymentAmount;
    // console.log('this.state.daoInfo', this.state.daoInfo.subscriptionCompleteDurationInDay);
    const currentTimeInSeconds = Math.floor(Date.now() / 1000);
    const additionalSeconds = this.state.daoInfo.subscriptionCompleteDurationInDay * 24 * 60 * 60;
    const endTimeInSeconds = currentTimeInSeconds + additionalSeconds;

    // Sử dụng newTimeInSeconds ở đâu đó trong mã của bạn
    // console.log('endTimeInSeconds', currentTimeInSeconds, endTimeInSeconds);
    if (this.state.paidCurrency === 'KAT') {
      if (
        this.state.katQuote > this.state.confirmedQuote * 1.001 ||
        this.state.katQuote < this.state.confirmedQuote * 0.009
      ) {
        this.openConfirmationDialog();
        // console.log("confirmedQuote", this.state.confirmedQuote.toString())
        if (this.state.confirmedQuote !== 0) {
          toast.info(I18n.t('payment_package_exchange_rate_changed'), {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: 'colored',
            className: 'toast-info-container',
          });
        }
      } else {
        const KATAddress = await revSharServiceContract.currencyAddresses(1);
        const KATSmartContract = new ethers.Contract(KATAddress, KATABI, this.signer);
        const KATdecimal = await KATSmartContract.decimals();

        paymentAmount = this.state.priceKat / this.state.katQuote;
        // console.log("Raw payment amount:", paymentAmount);

        // Làm tròn số: nếu nhỏ hơn 1 đơn vị nhỏ nhất thì coi như không thể thanh toán
        const paymentAmountFixed = parseFloat(paymentAmount).toFixed(KATdecimal);
        const paymentAmountBigNumber = ethers.utils.parseUnits(paymentAmountFixed, KATdecimal);
        // console.log("BigNumber payment amount:", paymentAmountBigNumber.toString());

        if (paymentAmountBigNumber.isZero()) {
          toast.info(I18n.t('payment_package_amount_too_small'), {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: 'colored',
            className: 'toast-info-container',
          });
          this.setState({
            infoStatus: '',
            infoNoti: '',
            isButtonDisabled: false,
            isButtonDisplay: true,
          });
          return;
        }

        // Get the current balance
        const currentBalance = await KATSmartContract.balanceOf(this.signer.getAddress());

        // Check if the current balance is less than the required payment amount
        if (currentBalance.lt(paymentAmountBigNumber)) {
          toast.info(I18n.t('payment_package_insufficient_balance'), {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: 'colored',
            className: 'toast-info-container',
          });
          this.setState({
            infoStatus: '',
            infoNoti: '',
            isButtonDisabled: false,
            isButtonDisplay: true,
          });

          console.error('Insufficient balance');
          return;
        }

        // Get the current allowance
        const currentAllowance = await KATSmartContract.allowance(
          this.signer.getAddress(),
          this.state.ServiceRevShareAddress,
        );

        // Check if the current allowance is less than the required payment amount
        if (currentAllowance.lt(paymentAmountBigNumber)) {
          // Increase the allowance by the difference between the payment amount and the current allowance
          // console.log("currentAllowance", currentAllowance);

          const increaseAmount = paymentAmountBigNumber.sub(currentAllowance);
          try {
            try {
              const increaseAllowanceResponse = await KATSmartContract.increaseAllowance(
                this.state.ServiceRevShareAddress,
                increaseAmount,
              );
              this.setState({ infoStatus: 'loading' });
              this.setState({ infoNoti: ' ' });
              await increaseAllowanceResponse.wait();
            } catch {
              toast.info(I18n.t('payment_package_need_to_increase_allowance'), {
                position: 'top-center',
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: 'colored',
                className: 'toast-info-container',
              });
              this.setState({
                infoStatus: '',
                infoNoti: '',
                isButtonDisabled: false,
                isButtonDisplay: true,
              });

              return;
            }

            // Call the buySubscription method
            try {
              this.setState({ infoStatus: '' });

              this.setState({ infoNoti: I18n.t('payment_package_confirm_payment') });
              const transactionResponse = await revSharServiceContract.buySubscription(
                orderID,
                0,
                KATAddress,
                this.state.packageId,
                this.state.packageTitle,
                paymentAmountBigNumber,
                endTimeInSeconds,
                { value: 0 } // Truyền giá trị BNB vào giao dịch

              );
              this.setState({ infoStatus: 'loading' });
              this.setState({ infoNoti: ' ' });
              const transactionReceipt = await transactionResponse.wait();
              // Tạo dataRequest sau khi thanh toán thành công

              const dataRequest = {
                // orderID: orderID,
                transactionId: transactionReceipt.transactionHash,
                // paidCurrency: this.state.paidCurrency,
                chainId: this.state.chainID,
                // packageTitle: this.state.packageTitle,
                // paymentAmount: paymentAmountBigNumber.toString(),
                // Thêm bất kỳ trường dữ liệu nào khác cần thiết cho hàm tiếp theo
              };
              // console.log("transactionReceipt", transactionReceipt);

              // Giả sử bạn có một hàm register cần dataRequest
              // console.log("dataRequest", dataRequest);
              try {
                const resgiterPackage = await registerPackage(dataRequest);
                this.setState({ infoStatus: 'loading' });
                this.setState({ infoNoti: I18n.t('payment_package_processing') });
                if (resgiterPackage.success === true) {
                  this.setState({ infoStatus: 'success' });
                  this.setState({
                    infoNoti: I18n.t('payment_package_payment_successful'),
                  });
                  try {
                    await fetchUserMvp();
                  } catch (e) {
                    console.error('Failed to refresh user info after KAT payment:', e);
                  }
                } else {
                  this.setState({ infoStatus: 'fail' });
                  this.setState({
                    infoNoti: `${I18n.t('payment_package_payment_failed')} ${resgiterPackage.error}`,
                  });
                }
              } catch (error) {
                console.error(error);
                this.setState({ infoStatus: 'fail' });
                this.setState({ infoNoti: I18n.t('payment_package_payment_failed') , error });
              }
            } catch (error) {
              this.setState({
                infoStatus: '',
                infoNoti: I18n.t('payment_package_payment_failed_try_again'),
                isButtonDisabled: false,
                isButtonDisplay: true,
              });
            }
          } catch (error) {
            console.error(error);
          }
        } else {
          try {
            this.setState({ infoStatus: '' });

            this.setState({ infoNoti: I18n.t('payment_package_confirm_payment') });
            const transactionResponse = await revSharServiceContract.buySubscription(
              orderID,
              0,
              KATAddress,
              this.state.packageId,
              this.state.packageTitle,
              paymentAmountBigNumber,
              endTimeInSeconds,
              { value: 0 } // Truyền giá trị BNB vào giao dịch

            );
            this.setState({ infoStatus: 'loading' });
            this.setState({ infoNoti: ' ' });
            const transactionReceipt = await transactionResponse.wait();

            // Tạo dataRequest sau khi thanh toán thành công
            const dataRequest = {
              transactionId: transactionReceipt.transactionHash,
              chainId: this.state.chainID,
            };

            // Giả sử bạn có một hàm register cần dataRequest
            // console.log("dataRequest", dataRequest);
            try {
              const resgiterPackage = await registerPackage(dataRequest);
              console.log('resgiterPackage', resgiterPackage, dataRequest);
              this.setState({ infoStatus: 'loading' });
              this.setState({ infoNoti: I18n.t('payment_package_processing') });
              if (resgiterPackage.success === true) {
                this.setState({ infoStatus: 'success' });
                this.setState({
                  infoNoti: I18n.t('payment_package_payment_successful'),
                });
                try {
                  await fetchUserMvp();
                } catch (e) {
                  console.error('Failed to refresh user info after KAT payment:', e);
                }
              } else {
                this.setState({ infoStatus: 'fail' });
                this.setState({ infoNoti: `${I18n.t('payment_package_payment_failed')} ${resgiterPackage.error}` });
              }
            } catch (error) {
              console.error(error);
              this.setState({ infoStatus: 'fail' });
              this.setState({ infoNoti: I18n.t('payment_package_payment_failed'), error });
            }
          } catch (error) {
            this.setState({
              infoStatus: '',
              infoNoti: I18n.t('payment_package_payment_failed_try_again'),
              isButtonDisabled: false,
              isButtonDisplay: true,
            });
          }
        }
      }
    } else if (this.state.paidCurrency === 'USDT') {
      if (
        this.state.usdtQuote > this.state.confirmedQuote * 1.001 ||
        this.state.usdtQuote < this.state.confirmedQuote * 0.009
      ) {
        // if (true) {
        this.openConfirmationDialog();
        if (this.state.confirmedQuote !== 0) {
          // console.log("confirmedQuote 123", this.state.confirmedQuote)

          toast.info(I18n.t('payment_package_exchange_rate_changed'), {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: 'colored',
            className: 'toast-info-container',
          });
        }
      } else {
        const USDTAddress = await revSharServiceContract.currencyAddresses(0);
        const USDTSmartContract = new ethers.Contract(USDTAddress, USDTABI, this.signer);
        const USDTdecimal = await USDTSmartContract.decimals();

        paymentAmount = this.state.priceUsdt / this.state.usdtQuote;
        // console.log("Raw payment amount:", paymentAmount);

        // Làm tròn số thập phân để tránh lỗi
        const paymentAmountFixed = parseFloat(paymentAmount).toFixed(USDTdecimal);
        // console.log("Fixed payment amount:", paymentAmountFixed);

        const paymentAmountBigNumber = ethers.utils.parseUnits(paymentAmountFixed, USDTdecimal);
        console.log("BigNumber payment amount:", paymentAmountBigNumber.toString());

        if (paymentAmountBigNumber.isZero()) {
          toast.info(I18n.t('payment_package_amount_too_small'), {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: 'colored',
            className: 'toast-info-container',
          });
          this.setState({
            infoStatus: '',
            infoNoti: '',
            isButtonDisabled: false,
            isButtonDisplay: true,
          });
          return;
        }

        // Get the current balance
        const currentBalance = await USDTSmartContract.balanceOf(this.state.walletAddress);
        // console.log("currentBalance", currentBalance.toString());
        // Check if the current balance is less than the required payment amount
        if (currentBalance.lt(paymentAmountBigNumber)) {
          // alert("Không đủ số dư để thực hiện giao dịch");
          toast.info(I18n.t('payment_package_insufficient_balance'), {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: 'colored',
            className: 'toast-info-container',
          });
          this.setState({
            infoStatus: '',
            infoNoti: '',
            isButtonDisabled: false,
            isButtonDisplay: true,
          });
          console.error('Insufficient balance');
          return;
        }

        // Get the current allowance
        const currentAllowance = await USDTSmartContract.allowance(
          this.signer.getAddress(),
          this.state.ServiceRevShareAddress,
        );

        // Check if the current allowance is less than the required payment amount
        if (currentAllowance.lt(paymentAmountBigNumber)) {
          // Increase the allowance by the difference between the payment amount and the current allowance
          // console.log("currentAllowance", currentAllowance);
          // this.setState({ infoStatus: '' });
          // this.setState({ infoNoti: I18n.t('payment_package_need_to_increase_allowance') });
          const increaseAmount = paymentAmountBigNumber.sub(currentAllowance);
          let allowanceTxSuccess = false;
          try {
            try {
              const increaseAllowanceResponse = await USDTSmartContract.increaseAllowance(
                this.state.ServiceRevShareAddress,
                increaseAmount,
              );
              this.setState({ infoStatus: 'loading' });
              this.setState({ infoNoti: ' ' });

              await increaseAllowanceResponse.wait();
              allowanceTxSuccess = true;
            } catch (increaseErr) {
              console.warn('increaseAllowance failed, trying approve() fallback:', increaseErr?.message || increaseErr);
              // Fallback: token chỉ có approve() (vd. USDT chính thức, USDT tự deploy testnet)
              const approveResponse = await USDTSmartContract.approve(
                this.state.ServiceRevShareAddress,
                paymentAmountBigNumber,
              );
              this.setState({ infoStatus: 'loading' });
              this.setState({ infoNoti: ' ' });
              await approveResponse.wait();
              allowanceTxSuccess = true;
            }

            if (!allowanceTxSuccess) {
              toast.info(I18n.t('payment_package_need_to_increase_allowance'), {
                position: 'top-center',
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: 'colored',
                className: 'toast-info-container',
              });
              this.setState({
                infoStatus: '',
                infoNoti: '',
                isButtonDisabled: false,
                isButtonDisplay: true,
              });
              return;
            }

            try {
              this.setState({ infoStatus: '' });

              this.setState({ infoNoti: I18n.t('payment_package_confirm_payment') });
              const transactionResponse = await revSharServiceContract.buySubscription(
                orderID,
                0,
                USDTAddress,
                this.state.packageId,
                this.state.packageTitle,
                paymentAmountBigNumber,
                endTimeInSeconds,
                { value: 0 } // Truyền giá trị BNB vào giao dịch
              );
              this.setState({ infoStatus: 'loading' });
              this.setState({ infoNoti: ' ' });
              const transactionReceipt = await transactionResponse.wait();

              // Tạo dataRequest sau khi thanh toán thành công
              const dataRequest = {
                // orderID: orderID,
                transactionId: transactionReceipt.transactionHash,
                // transactionId: "0x03ed32d153dac98c23c8ec82d7cdd97cb9e5a5d44463d448dc97a82f9dff4ffe",
                // paidCurrency: this.state.paidCurrency,
                chainId: this.state.chainID,
                // packageTitle: this.state.packageTitle,
                // paymentAmount: paymentAmountBigNumber.toString(),
                // Thêm bất kỳ trường dữ liệu nào khác cần thiết cho hàm tiếp theo
              };

              // Giả sử bạn có một hàm register cần dataRequest
              // console.log("dataRequest", dataRequest);
              try {
                const resgiterPackage = await registerPackage(dataRequest);
                console.log('resgiterPackage', resgiterPackage, dataRequest);
                this.setState({ infoStatus: 'loading' });
                this.setState({ infoNoti: I18n.t('payment_package_processing') });
                if (resgiterPackage.success === true) {
                  this.setState({ infoStatus: 'success' });
                  this.setState({
                    infoNoti: I18n.t('payment_package_payment_successful'),
                  });
                  try {
                    await fetchUserMvp();
                  } catch (e) {
                    console.error('Failed to refresh user info after USDT payment:', e);
                  }
                } else {
                  this.setState({ infoStatus: 'fail' });
                  this.setState({
                    infoNoti: `${I18n.t('payment_package_payment_failed')} ${resgiterPackage.error}`,
                  });
                }
              } catch (error) {
                console.error(error);
                this.setState({ infoStatus: 'fail' });
                this.setState({ infoNoti: I18n.t('payment_package_payment_failed'), error });
              }
            } catch (error) {
              console.error(error);
            }
          } catch (error) {
            this.setState({
              infoStatus: '',
              infoNoti: I18n.t('payment_package_payment_failed_try_again'),
              isButtonDisabled: false,
              isButtonDisplay: true,
            });
            console.error(error);
          }
          // Call the buySubscription method
        } else {
          try {
            this.setState({ infoStatus: '' });

            this.setState({ infoNoti: I18n.t('payment_package_confirm_payment') });
            const transactionResponse = await revSharServiceContract.buySubscription(
              orderID,
              0,
              USDTAddress,
              this.state.packageId,
              this.state.packageTitle,
              paymentAmountBigNumber,
              endTimeInSeconds,
              { value: 0 } // Truyền giá trị BNB vào giao dịch
            );
            this.setState({ infoStatus: 'loading' });
            this.setState({ infoNoti: ' ' });
            const transactionReceipt = await transactionResponse.wait();

            const dataRequest = {
              transactionId: transactionReceipt.transactionHash,
              chainId: this.state.chainID,
            };

            try {
              const resgiterPackage = await registerPackage(dataRequest);
              console.log('resgiterPackage', resgiterPackage, dataRequest);
              this.setState({ infoStatus: 'loading' });
              this.setState({ infoNoti: I18n.t('payment_package_processing') });
              if (resgiterPackage.success === true) {
                this.setState({ infoStatus: 'success' });
                this.setState({
                  infoNoti: I18n.t('payment_package_payment_successful'),
                });
                try {
                  await fetchUserMvp();
                } catch (e) {
                  console.error('Failed to refresh user info after USDT payment:', e);
                }
              } else {
                this.setState({ infoStatus: 'fail' });
                this.setState({ infoNoti: `${I18n.t('payment_package_payment_failed')} ${resgiterPackage.error}` });
              }
            } catch (error) {
              console.error(error);
              this.setState({ infoStatus: 'fail' });
              this.setState({ infoNoti: I18n.t('payment_package_payment_failed'), error });
            }
          } catch (error) {
            this.setState({
              infoStatus: '',
              infoNoti: I18n.t('payment_package_payment_failed_try_again'),
              isButtonDisabled: false,
              isButtonDisplay: true,
            });
          }
        }
      }
    } else if (this.state.paidCurrency === 'PAXG') {
      if (
        this.state.paxgQuote > this.state.confirmedQuote * 1.001 ||
        this.state.paxgQuote < this.state.confirmedQuote * 0.009
      ) {
        // if (true) {
        this.openConfirmationDialog();
        if (this.state.confirmedQuote !== 0) {
          // console.log("confirmedQuote 123", this.state.confirmedQuote)

          toast.info(I18n.t('payment_package_exchange_rate_changed'), {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: 'colored',
            className: 'toast-info-container',
          });
        }
      } else {
        const PAXGAddress = await revSharServiceContract.currencyAddresses(2);
        const PAXGSmartContract = new ethers.Contract(PAXGAddress, PAXGABI, this.signer);
        const PAXGdecimal = await PAXGSmartContract.decimals();
        paymentAmount = this.state.priceUsdt / this.state.paxgQuote;
        // console.log("payment amount", paymentAmount)
        // console.log("PAXGdecimal type:", typeof PAXGdecimal, "value:", PAXGdecimal);

        // const decimals = PAXGdecimal; // Đảm bảo PAXGdecimal có giá trị hợp lệ
        const paymentAmountFixed = parseFloat(paymentAmount).toFixed(PAXGdecimal); // Giới hạn số chữ số thập phân
        const paymentAmountBigNumber = ethers.utils.parseUnits(paymentAmountFixed, PAXGdecimal);

        if (paymentAmountBigNumber.isZero()) {
          toast.info(I18n.t('payment_package_amount_too_small'), {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: 'colored',
            className: 'toast-info-container',
          });
          this.setState({
            infoStatus: '',
            infoNoti: '',
            isButtonDisabled: false,
            isButtonDisplay: true,
          });
          return;
        }

        // const paymentAmountBigNumber = ethers.utils.parseUnits(paymentAmount.toString(), PAXGdecimal); // 18 is the number of decimal places for Ether
        // console.log('paymentAmountBigNumber', paymentAmountBigNumber)
        // Get the current balance
        const currentBalance = await PAXGSmartContract.balanceOf(this.state.walletAddress);
        // console.log("currentBalance", currentBalance.toString());
        // Check if the current balance is less than the required payment amount
        if (currentBalance.lt(paymentAmountBigNumber)) {
          // alert("Không đủ số dư để thực hiện giao dịch");
          toast.info(I18n.t('payment_package_insufficient_balance'), {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: 'colored',
            className: 'toast-info-container',
          });
          this.setState({
            infoStatus: '',
            infoNoti: '',
            isButtonDisabled: false,
            isButtonDisplay: true,
          });
          console.error('Insufficient balance');
          return;
        }

        // Get the current allowance
        const currentAllowance = await PAXGSmartContract.allowance(
          this.signer.getAddress(),
          this.state.ServiceRevShareAddress,
        );

        // Check if the current allowance is less than the required payment amount
        if (currentAllowance.lt(paymentAmountBigNumber)) {
          // Increase the allowance by the difference between the payment amount and the current allowance
          // console.log("currentAllowance", currentAllowance);
          // this.setState({ infoStatus: '' });
          // this.setState({ infoNoti: I18n.t('payment_package_need_to_increase_allowance') });
          const increaseAmount = paymentAmountBigNumber.sub(currentAllowance);
          try {
            try {
              const increaseAllowanceResponse = await PAXGSmartContract.increaseAllowance(
                this.state.ServiceRevShareAddress,
                increaseAmount,
              );
              this.setState({ infoStatus: 'loading' });
              this.setState({ infoNoti: ' ' });

              await increaseAllowanceResponse.wait();
            } catch {
              toast.info(I18n.t('payment_package_need_to_increase_allowance'), {
                position: 'top-center',
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: 'colored',
                className: 'toast-info-container',
              });
              this.setState({
                infoStatus: '',
                infoNoti: '',
                isButtonDisabled: false,
                isButtonDisplay: true,
              });
              return;
            }

            try {
              this.setState({ infoStatus: '' });

              this.setState({ infoNoti: I18n.t('payment_package_confirm_payment') });
              const transactionResponse = await revSharServiceContract.buySubscription(
                orderID,
                0,
                PAXGAddress,
                this.state.packageId,
                this.state.packageTitle,
                paymentAmountBigNumber,
                endTimeInSeconds,
                { value: 0 } // Truyền giá trị BNB vào giao dịch
              );
              this.setState({ infoStatus: 'loading' });
              this.setState({ infoNoti: ' ' });
              const transactionReceipt = await transactionResponse.wait();

              // Tạo dataRequest sau khi thanh toán thành công
              const dataRequest = {
                // orderID: orderID,
                transactionId: transactionReceipt.transactionHash,
                // transactionId: "0x03ed32d153dac98c23c8ec82d7cdd97cb9e5a5d44463d448dc97a82f9dff4ffe",
                // paidCurrency: this.state.paidCurrency,
                chainId: this.state.chainID,
                // packageTitle: this.state.packageTitle,
                // paymentAmount: paymentAmountBigNumber.toString(),
                // Thêm bất kỳ trường dữ liệu nào khác cần thiết cho hàm tiếp theo
              };

              // Giả sử bạn có một hàm register cần dataRequest
              // console.log("dataRequest", dataRequest);
              try {
                const resgiterPackage = await registerPackage(dataRequest);
                console.log('resgiterPackage', resgiterPackage, dataRequest);
                this.setState({ infoStatus: 'loading' });
                this.setState({ infoNoti: I18n.t('payment_package_processing') });
                if (resgiterPackage.success === true) {
                  this.setState({ infoStatus: 'success' });
                  this.setState({
                    infoNoti: I18n.t('payment_package_payment_successful'),
                  });
                  try {
                    await fetchUserMvp();
                  } catch (e) {
                    console.error('Failed to refresh user info after PAXG payment:', e);
                  }
                } else {
                  this.setState({ infoStatus: 'fail' });
                  this.setState({
                    infoNoti: `${I18n.t('payment_package_payment_failed')} ${resgiterPackage.error}`,
                  });
                }
              } catch (error) {
                console.error(error);
                this.setState({ infoStatus: 'fail' });
                this.setState({ infoNoti: I18n.t('payment_package_payment_failed'), error });
              }
            } catch (error) { }
          } catch (error) {
            this.setState({
              infoStatus: '',
              infoNoti: I18n.t('payment_package_payment_failed_try_again'),
              isButtonDisabled: false,
              isButtonDisplay: true,
            });
            console.error(error);
          }
          // Call the buySubscription method
        } else {
          try {
            this.setState({ infoStatus: '' });

            this.setState({ infoNoti: I18n.t('payment_package_confirm_payment') });
            const transactionResponse = await revSharServiceContract.buySubscription(
              orderID,
              0,
              PAXGAddress,
              this.state.packageId,
              this.state.packageTitle,
              paymentAmountBigNumber,
              endTimeInSeconds,
              { value: 0 } // Truyền giá trị BNB vào giao dịch
            );
            this.setState({ infoStatus: 'loading' });
            this.setState({ infoNoti: ' ' });
            const transactionReceipt = await transactionResponse.wait();

            const dataRequest = {
              transactionId: transactionReceipt.transactionHash,
              chainId: this.state.chainID,
            };

            try {
              const resgiterPackage = await registerPackage(dataRequest);
              console.log('resgiterPackage', resgiterPackage, dataRequest);
              this.setState({ infoStatus: 'loading' });
              this.setState({ infoNoti: I18n.t('payment_package_processing') });
              if (resgiterPackage.success === true) {
                this.setState({ infoStatus: 'success' });
                this.setState({
                  infoNoti: I18n.t('payment_package_payment_successful'),
                });
                try {
                  await fetchUserMvp();
                } catch (e) {
                  console.error('Failed to refresh user info after PAXG payment:', e);
                }
              } else {
                this.setState({ infoStatus: 'fail' });
                this.setState({
                  infoNoti: `${I18n.t('payment_package_payment_failed')} ${resgiterPackage.error}`,
                });
              }
            } catch (error) {
              console.error(error);
              this.setState({ infoStatus: 'fail' });
              this.setState({ infoNoti: I18n.t('payment_package_payment_failed'), error });
            }
          } catch (error) {
            this.setState({
              infoStatus: '',
              infoNoti: I18n.t('payment_package_payment_failed_try_again'),
              isButtonDisabled: false,
              isButtonDisplay: true,
            });
          }
        }
      }
    } else if (this.state.paidCurrency === 'BNB' || this.state.paidCurrency === 'ETH' || this.state.paidCurrency === 'POL' || this.state.paidCurrency === 'ZETA') {
      let currentQuote = this.state.bnbQuote;
      if (this.state.paidCurrency === 'ETH') {
        currentQuote = this.state.ethQuote;
      } else if (this.state.paidCurrency === 'ZETA') {
        currentQuote = this.state.zetaQuote;
      }
      if (
        currentQuote > this.state.confirmedQuote * 1.001 ||
        currentQuote < this.state.confirmedQuote * 0.009
      ) {
        // if (true) {
        this.openConfirmationDialog();
        if (this.state.confirmedQuote !== 0) {
          // console.log("confirmedQuote 123", this.state.confirmedQuote)

          toast.info(I18n.t('payment_package_exchange_rate_changed'), {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: 'colored',
            className: 'toast-info-container',
          });
        }
      } else {
        const BNB_ADDRESS = "0x0000000000000000000000000000000000000000";

        // Tính toán số lượng native token cần thanh toán

        let paymentAmount = this.state.priceUsdt / this.state.bnbQuote;
        if (this.state.paidCurrency === 'ETH') {
          paymentAmount = this.state.priceUsdt / this.state.ethQuote;
        } else if (this.state.paidCurrency === 'ZETA') {
          paymentAmount = this.state.priceUsdt / this.state.zetaQuote;
        }
        // Dùng chuỗi thập phân cố định 18 chữ số để tránh e-notation gây lỗi parseUnits
        const paymentAmountStr = Number(paymentAmount)
          .toFixed(18)
          .replace(/\.0+$/, '')
          .replace(/(\.\d*[1-9])0+$/, '$1');
        const paymentAmountBigNumber = ethers.utils.parseUnits(paymentAmountStr || '0', "ether"); // BNB sử dụng 18 decimal
        console.log('paymentAmount', paymentAmountStr)

        if (paymentAmountBigNumber.isZero()) {
          toast.info(I18n.t('payment_package_amount_too_small'), {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: 'colored',
            className: 'toast-info-container',
          });

          this.setState({
            infoStatus: '',
            infoNoti: '',
            isButtonDisabled: false,
            isButtonDisplay: true,
          });
          return;
        }
        // Lấy số dư hiện tại của BNB
        const currentBalance = await this.signer.getBalance();

        if (currentBalance.lt(paymentAmountBigNumber)) {
          toast.info(I18n.t('payment_package_insufficient_balance'), {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: 'colored',
            className: 'toast-info-container',
          });

          this.setState({
            infoStatus: '',
            infoNoti: '',
            isButtonDisabled: false,
            isButtonDisplay: true,
          });
          console.error('Insufficient ', this.state.paidCurrency, ' balance');
          return;
        }

        try {
          this.setState({ infoStatus: '' });
          this.setState({ infoNoti: I18n.t('payment_package_confirm_payment') });

          // Gọi hàm buySubscription trên smart contract với giá trị BNB cần gửi
          const transactionResponse = await revSharServiceContract.buySubscription(
            orderID,
            0,
            BNB_ADDRESS, // Địa chỉ token là 0x00 để chỉ định dùng BNB
            this.state.packageId,
            this.state.packageTitle,
            paymentAmountBigNumber,
            endTimeInSeconds,
            { value: paymentAmountBigNumber } // Truyền giá trị BNB vào giao dịch
          );

          this.setState({ infoStatus: 'loading' });
          this.setState({ infoNoti: ' ' });

          const transactionReceipt = await transactionResponse.wait();
          console.log('transactionReceipt', transactionReceipt)
          // Gửi dữ liệu giao dịch đến hệ thống backend
          const dataRequest = {
            transactionId: transactionReceipt.transactionHash,
            chainId: this.state.chainID,
          };

          try {
            const registerPackageResponse = await registerPackage(dataRequest);
            console.log('registerPackage', registerPackageResponse, dataRequest);

            this.setState({ infoStatus: 'loading' });
            this.setState({ infoNoti: I18n.t('payment_package_processing') });

            if (registerPackageResponse.success) {
              this.setState({ infoStatus: 'success' });
              this.setState({
                infoNoti: I18n.t('payment_package_payment_successful'),
              });
              try {
                await fetchUserMvp();
              } catch (e) {
                console.error('Failed to refresh user info after native token payment:', e);
              }
            } else {
              this.setState({ infoStatus: 'fail' });
              this.setState({
                infoNoti: `${I18n.t('payment_package_payment_failed')} ${registerPackageResponse.error}`,
              });
            }
          } catch (error) {
            console.error(error);
            this.setState({ infoStatus: 'fail' });
            this.setState({ infoNoti: `${I18n.t('payment_package_payment_failed')} ${error.message}` });
          }
        } catch (error) {
          this.setState({
            infoStatus: '',
            infoNoti: I18n.t('payment_package_payment_failed_try_again'),
            isButtonDisabled: false,
            isButtonDisplay: true,
          });
          console.error(error);
        }
      }
    }
  };
  handlePaymentButtonClick = async () => {
    // this.setState({ showConfirmationDialog: true });
    if (!this.state.ServiceRevShareAddress || !ethers.utils.isAddress(this.state.ServiceRevShareAddress)) {
      toast.info(I18n.t('payment_package_setup_error'), {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: 'colored',
        className: 'toast-info-container',
      });
    } else {
      this.handlePayment();
    }
  };
  closeConfirmationDialog = (value) => {
    this.getQuote();
    this.setState({
      showConfirmationDialog: false,
      isButtonDisabled: false,
      isButtonDisplay: true,
    });

    if (value) {
      this.setState({
        isButtonDisplay: false,
        confirmedQuote: value,
      });
      this.handlePayment();
    }
  };
  render() {
    return (
      <div>
        {this.state.showConfirmationDialog && (
          <ConfirmationDialog
            paidCurrency={this.state.paidCurrency}
            lastKATQuote={this.state.katQuote}
            lastUSDTQuote={this.state.usdtQuote}
            paidAmountOnUSD={
              this.state.paidCurrency === 'KAT'
                ? this.state.priceKat
                : this.state.paidCurrency === 'PAXG'
                  ? this.state.priceUsdt
                  : this.state.priceUsdt
            }
            packageId={this.state.packageId}
            packageTitle={this.state.packageTitle}
            chainID={this.state.chainID}
            serviceRevShareAddress={this.state.ServiceRevShareAddress}
            onClose={this.closeConfirmationDialog}
          />
        )}
        <div id="site_wrapper">
          <div className="site-upper">{this.props.header}</div>
          <main className="main-package-payment">
            <div className="container" style={{ paddingBottom: '50px' }}>
              <Box
                style={{
                  width: '100%',
                  height: 'auto',
                  gap: '64px',
                  alignItems: 'center',
                  marginTop: '20px',
                  marginBottom: '20px',
                }}
              >
                <img
                  src={arrowBackIosIcon}
                  alt="Arrow Back"
                  onClick={() => window.history.back()} // Add this line
                />
                <Typography
                  variant=""
                  className="your-package"
                  style={{
                    marginTop: '20px',
                    marginBottom: '20px',
                    marginLeft: '218px', // Add a left margin to the text
                    textAlign: 'center', // This aligns the text to the left
                  }}
                >
                  {I18n.t('package_detail')}
                </Typography>
              </Box>
              <CardPackagePayment
                title={this.state.packageTitle}
                // Truyền giá trị số, để CardPackagePayment tự format (tránh trường hợp giá rất nhỏ bị thành 0)
                priceKat={this.state.priceKat / this.state.katQuote}
                priceUsdt={this.state.priceUsdt / this.state.usdtQuote}
                // pricePaxg={(this.state.priceUsdt / this.state.paxgQuote).toFixed(6)}//giá PAXG thì phải tính theo USDT rồi chia ra
                totalSession={this.state.totalSession}
                totalDay={this.state.totalDay}
                packageMainColor={this.state.packageMainColor}
                startDate={this.state.startDate}
                endDate={this.state.endDate}
                currentPackageExpiredDate={this.state.currentPackageExpiredDate}
              ></CardPackagePayment>
            </div>
          </main>
          <div className="payment-area">
            {this.state.isButtonDisplay && (
              <Row className="rowHeight4">
                {' '}
                {'\u00A0'}
                <div className="smallBuy">{I18n.t('payment_method')}</div>
              </Row>
            )}

            {/* <Row className="rowHeight4"> {'\u00A0'} */}
            <div></div>
            {this.state.isButtonDisplay && (
              <div className="box1">
                {this.state.paidCurrency === 'KAT' ? (
                  <img style={{ width: '45px', height: '45px' }} src={KATlogo} />
                ) : this.state.paidCurrency === 'USDT' ? (
                  <img style={{ width: '45px', height: '45px' }} src={USDTlogo} />
                ) : this.state.paidCurrency === 'PAXG' ? (
                  <img style={{ width: '45px', height: '45px' }} src={PAXGlogo} />
                ) : this.state.paidCurrency === 'BNB' ? (
                  <img style={{ width: '45px', height: '45px' }} src={BNBlogo} />
                ) : this.state.paidCurrency === 'ETH' ? (
                  <img style={{ width: '45px', height: '45px' }} src={ETHlogo} />
                ) : this.state.paidCurrency === 'POL' ? (
                  <img style={{ width: '45px', height: '45px' }} src={POLlogo} />
                ) : this.state.paidCurrency === 'ZETA' ? (
                  <img style={{ width: '45px', height: '45px' }} src={ZETAlogo} />
                ) : null}
                <Box sx={{ maxWidth: 70 }} className="selectCurrency">
                  <FormControl fullWidth className="selectBox" variant="standard">
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={this.state.paidCurrency}
                      label="I will pay by"
                      onChange={this.handleChangeCurrency}
                      sx={{
                        '& .MuiSelect-icon': {
                          // color: 'white', // Change the color of the select icon to white
                        },
                      }}
                    >
                      <MenuItem value={'KAT'}>KAT</MenuItem>
                      <MenuItem value={'USDT'}>USDT</MenuItem>
                      {(this.state.chainID === '1' || this.state.chainID === '137') && (
                        <MenuItem value={'PAXG'}>PAXG</MenuItem>
                      )}{' '}
                      {(this.state.chainID === '1') && (
                        <MenuItem value={'ETH'}>ETH</MenuItem>
                      )}{' '}
                      {(this.state.chainID === '56') && (
                        <MenuItem value={'BNB'}>BNB</MenuItem>
                      )}{' '}
                      {(this.state.chainID === '137') && (
                        <MenuItem value={'POL'}>POL</MenuItem>
                      )}{' '}
                      {(this.state.chainID === '7001') && (
                        <MenuItem value={'ZETA'}>ZETA</MenuItem>
                      )}{' '}
                    </Select>
                  </FormControl>
                </Box>
                <div className="paidAmount">
                  {this.state.paidCurrency === 'KAT'
                    ? this.formatAmount(this.state.priceKat / this.state.katQuote)
                    : this.state.paidCurrency === 'PAXG'
                      ? this.formatAmount(this.state.priceUsdt / this.state.paxgQuote)
                      : this.state.paidCurrency === 'BNB'
                        ? this.formatAmount(this.state.priceUsdt / this.state.bnbQuote)
                        : this.state.paidCurrency === 'POL'
                          ? this.formatAmount(this.state.priceUsdt / this.state.bnbQuote)
                          : this.state.paidCurrency === 'ETH'
                            ? this.formatAmount(this.state.priceUsdt / this.state.ethQuote)
                            : this.state.paidCurrency === 'ZETA'
                              ? this.formatAmount(this.state.priceUsdt / this.state.zetaQuote)
                              : this.formatAmount(this.state.priceUsdt / this.state.usdtQuote)
                  }{' '}
                  {this.state.paidCurrency}
                </div>
              </div>
            )}

            {this.state.infoNoti !== '' && (
              <div className="info-area">
                {this.state.infoStatus === 'success' && (
                  <img style={{ width: '120px', height: '120px' }} src={successIcon} />
                )}
                {this.state.infoStatus === 'loading' && (
                  <img style={{ width: '80px', height: '80px' }} src={loadingIcon} />
                )}

                <Typography className="notice-infor">{this.state.infoNoti}</Typography>
              </div>
            )}
            {this.state.isButtonDisplay && (
              <Button
                className="button-payment"
                onClick={this.handlePaymentButtonClick}
                disabled={this.state.isButtonDisabled}
              >
                {I18n.t('pay_now')}
              </Button>
            )}
          </div>

          {this.props.footer}
        </div>
      </div>
    );
  }
}
const mapDispatchToProps = {
  getKatUSDTQuote,
  getCedPackageById,
  getDaoDetailByCode,
  registerPackage,
  getWalletSessionByUserId,
  fetchUserMvp,
};
export default withRouter(connect(null, mapDispatchToProps)(Payment));
